<script>
import { payment } from "@/assets/static.js";
import { active } from "@/assets/static.js";
import { work } from "@/assets/static.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Loader from "@/components/custom/Loader.vue";
export default {
  name: "EmployeesModalView",
  props: {
    value: Boolean,
    id: Int16Array,
  },
  data() {
    return {
      dialog: this.value,
      date: new Date().toISOString().substr(0, 10),
      employeeDate: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menuEmployeeDate: false,
      selectedStatusItems: [],
      selectedPaymenItems: [],
      selectedJobItems: [],
      paymentList: payment,
      activeList: active,
      jobList: work,
      file: null,
      image: null,
      selectedId: this.$props.id,
      EmpSkillsList: [],
    };
  },
  watch: {
    value(newValue) {
      this.dialog = newValue;
    },
    dialog(newDialogValue) {
      this.$emit("input", newDialogValue);
    },
    isLoading(isLoading) {
      if (isLoading) {
        this.dialog = true;
      } else {
        this.dialog = false;
      }
    },
  },
  computed: {
    ...mapGetters([
      "departmentsListGet",
      "employeeByIdGet",
      "employeeSkillsGet",
      "isLoadingGet",
    ]),
    employee() {
      return this.employeeByIdGet;
    },
    isLoading() {
      return this.isLoadingGet;
    },
    getEmpSkills() {
      return this.employeeSkillsGet;
    },
  },
  mounted() {
    this.employeeByIdSet(null);
    this.getEmployeeById(this.selectedId);
    this.getEmployeeSkills({ isModal: true, id: this.$props.id });
  },
  methods: {
    ...mapMutations(["SET_LOADING", "employeeByIdSet"]),
    ...mapActions([
      "set_page",
      "addEmployee",
      "getDepartments",
      "getEmployeeById",
      "editEmployee",
      "getEmployeeSkills",
    ]),
    getNameTranslated(item) {
      return this.$t(item.name);
    },

    openPDF() {
      // console.log(this.employee, "empl");
      window.open(this.employee.cv, "_blank");
    },
    funnn() {
      console.log("EmpSkillsList", this.employeeSkillsGet[0]);
    },
  },
  components: {
    Loader,
  },
};
</script>
<style scoped>
.backGround {
  background-color: var(--v-gray2-base) !important;
}
.backGroundCard {
  background-color: var(--v-prime-base) !important;
}
.selectItem {
  color: var(--v-orange-base) !important;
}
.orange-icon ::v-deep .v-icon.mdi {
  color: orange;
}
</style>

<template>
  <v-dialog v-model="dialog" width="80%">
    <Loader v-if="isLoading || this.employee === null" />
    <v-card v-else class="backGround">
      <v-card-actions class="justify-end">
        <v-btn color="orange" flat @click.stop="dialog = false">
          <v-icon color="white">mdi-close-thick</v-icon></v-btn
        >
      </v-card-actions>
      <v-card-actions class="justify-center align-center">
        <v-sheet
          class="avatar_container transparent d-flex align-center justify-center"
          width="25%"
        >
          <v-avatar width="55%" height="100%" class="avatar">
            <!-- <img v-bind:src="require()" /> -->
            <img :src="employee.image" alt="image" />
          </v-avatar>
        </v-sheet>
      </v-card-actions>
      <template>
        <v-form v-model="valid">
          <v-container>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  readonly
                  v-model="employee.name"
                  :rules="nameRules"
                  :label="$t('employeeName')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  readonly
                  v-model="employee.father_name"
                  :rules="nameRules"
                  :label="$t('midName')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  readonly
                  v-model="employee.l_name"
                  :rules="emailRules"
                  :label="$t('lastName')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  readonly
                  :rules="emailRules"
                  :label="$t(employee.gender)"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-menu
                  readonly
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="birthday"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="employee.birthday"
                      :label="$t('dateOfBreath')"
                      prepend-inner-icon="mdi-calendar"
                      class="orange-icon"
                      readonly
                      :hint="$t('dateOfBreath')"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      color="orange"
                    ></v-text-field>
                  </template>
                </v-menu>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="employee.mother_name"
                  :rules="nameRules"
                  :label="$t('motherName')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="employee.email"
                  :rules="emailRules"
                  :label="$t('email')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  type="number"
                  v-model="employee.currentSalary"
                  :label="$t('currentSalary')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>

              <!-- <v-select
                readonly
                v-model="employee.department"
                :label="$t('departments')"
                :items="departmentsListGet"
                item-text="name"
                item-value="id"
                return-object
                persistent-hint
                 outlined
                        color="orange"
                color="orange--text"
                item-color="orange"
                class="ma-1"
              >
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on">
                    <v-list-item-action>
                      <v-simple-checkbox
                        :value="attrs.inputValue"
                        v-on="on"
                        color="orange"
                        :ripple="false"
                      ></v-simple-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title
                        :class="attrs.inputValue ? 'orange--text' : ''"
                        >{{ $t(item.name) }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select> -->
              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="employee.emergency_person"
                  :label="$t('emergencyPerson')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="employee.personal_id"
                  :label="$t('personalID')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="employee.phone"
                  :label="$t('phone')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="employee.emergency_number"
                  :rules="nameRules"
                  :label="$t('emergencyNumber')"
                  required
                  outlined
                  color="orange"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <p>{{ $t("employee cv") }}</p>
                <v-img
                  max-width="130px"
                  class="mr-8"
                  src="@/assets/images/pdf.png"
                  @click="openPDF()"
                  style="cursor: pointer"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="8">
                <v-row>
                  <h3 class="gray1--text mt-3">{{ $t("skils") }}</h3>
                </v-row>
                <v-sheet
                  class="transparent"
                  v-for="skill in getEmpSkills"
                  :key="skill.id"
                >
                  <div class="d-flex align-center justify-space-between">
                    <span class="pa-2">{{ skill.skillName }}</span>

                    <v-progress-linear
                      color="orange"
                      model-value="10"
                      :height="13"
                      :value="(skill.skillValue * 100) / 10"
                      label="Progress"
                      class="mt-2"
                    >
                      <template v-slot:default="{ value }">
                        <h5>{{ Math.ceil(value) }}%</h5>
                      </template>
                    </v-progress-linear>
                  </div>
                  <br />
                </v-sheet>
              </v-col>
            </v-row>
            <!-- <v-row class="justify-end">
              <v-btn
                outlined
                color="gray0"
                bordercolor="bordo"
                class="ma-4"
                id="deleteEmployeeBtn"
                width="200px"
                @click.stop="dialog = false"
              >
                <v-icon color="bordo" class="pa-2">mdi-account-remove</v-icon>
                <h3 class="bordo--text">
                  {{ $t("cancel") }}
                </h3></v-btn
              >
            </v-row> -->
          </v-container>
        </v-form>
      </template>
    </v-card>
  </v-dialog>
</template>
